// getText 获取文字(可能存在使用多语言插件vue-i18n的情况)

export default function (that = null, text = [], defaultI18n = '', defaultText = '') {
    // that = this = vue实例 this.myVue
    // text 数组文字
    // defaultI18n 默认多语言的key
    // defaultText 默认文字
    if (that && that.myVue && that.myVue.$t) {
        if (text && Array.isArray(text) && text.length) {
            return that.myVue.$t(...text);
        }
        if (defaultI18n) {
            return that.myVue.$t(defaultI18n);
        }
    }
    // // 不考虑使用默认的text
    // if (text && Array.isArray(text) && text.length) {
    //     return text;
    // }
    return defaultText;
}